import React from "react";
import PropTypes from "prop-types";

export const LESSON_SUMMARY_MAX_LENGTH = 600;

const trimToLimit = value => Array.from(value).slice(0, LESSON_SUMMARY_MAX_LENGTH).join("");

const LessonSummaryPanel = ({ value, canEdit, onChange, onShowHistory }) => (
  <section className="attendance-page__lesson-summary" aria-labelledby="lesson-summary-title">
    <div className="attendance-page__lesson-summary-heading">
      <div>
        <h2 id="lesson-summary-title">Temat i podsumowanie lekcji</h2>
        <p>Napisz krótko, najlepiej 2–3 zdania, czego dotyczyły zajęcia i co robili uczniowie.</p>
      </div>
      <button type="button" className="btn manage-button manage-teal-button" onClick={onShowHistory}>
        Poprzednie tematy
      </button>
    </div>
    <label htmlFor="lesson-summary" className="sr-only">Temat i podsumowanie lekcji</label>
    <textarea
      id="lesson-summary"
      className="form-control"
      rows="4"
      value={value}
      disabled={!canEdit}
      placeholder="Np. Powtórzyliśmy czas Past Simple i ćwiczyliśmy opowiadanie o weekendzie. Uczniowie pracowali w parach i wykonali zadania z rozdziału 4."
      onChange={event => onChange(trimToLimit(event.target.value))}
    />
    <div className="attendance-page__lesson-summary-meta">
      <span>Pole opcjonalne</span>
      <span>{Array.from(value).length}/{LESSON_SUMMARY_MAX_LENGTH}</span>
    </div>
  </section>
);

LessonSummaryPanel.propTypes = {
  value: PropTypes.string,
  canEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onShowHistory: PropTypes.func.isRequired,
};

LessonSummaryPanel.defaultProps = { value: "" };

export default LessonSummaryPanel;
